import React from "react";
import styles from "./index.module.css"
import Login from "../../components/Login";
import Slider from "../../components/Slider";

const Authorization = () =>{
    return(
        <div className={styles.wrapper}>
            <Login />
            <Slider/>
        </div>
    )
}
export default Authorization;